export enum Role {
  SUPER_ADMIN = 'super-admin',
  ADMIN = 'admin',
  BERATER = 'berater',
  PARTICIPANT = 'participant',
  USER = 'user',
  LECTURER = 'lecturer',
}

export enum Permission {
  ADD_INSTITUTIONS = 'add-institutions',
  MANAGE_INSTITUTION = 'manage-institution',
  MANAGE_PARTICIPATION = 'manage-participation',
  MANAGE_USER = 'manage-user',
  MANAGE_GLOBAL_MAIL_TEMPLATES = 'manage-global-mail-templates',

  // admin view permissions
  VIEW_SUPER_ADMIN_SIDEBAR = 'view-super-admin-sidebar',
  VIEW_ADMIN_DASHBOARD = 'view-admin-dashboard',
  VIEW_ADMIN_INSTITUTION = 'view-admin-institution',
  VIEW_ADMIN_INSTITUTION_DASHBOARD = 'view-admin-institution-dashboard',
  VIEW_ADMIN_INSTITUTION_WORKSHOPS = 'view-admin-institution-workshops',
  VIEW_ADMIN_INSTITUTION_COUNSELINGS = 'view-admin-institution-counselings',
  VIEW_ADMIN_INSTITUTION_BUNDLES = 'view-admin-institution-bundles',
  VIEW_ADMIN_INSTITUTION_TIMEFRAMES = 'view-admin-institution-timeframes',
  VIEW_ADMIN_INSTITUTION_CATEGORIES = 'view-admin-institution-categories',
  VIEW_ADMIN_INSTITUTION_USERS = 'view-admin-institution-users',
  VIEW_ADMIN_INSTITUTION_FORM_CONFIG = 'view-admin-institution-form-config',
  VIEW_ADMIN_INSTITUTION_SETTINGS = 'view-admin-institution-settings',
  VIEW_ADMIN_INSTITUTION_EXPORTS = 'view-admin-institution-exports',
  VIEW_ADMIN_INSTITUTION_LECTURERS = 'view-admin-institution-lecturers',

  // admin edit permissions
  EDIT_ADMIN_INSTITUTION = 'edit-admin-institution',
  EDIT_ADMIN_INSTITUTION_WORKSHOPS = 'edit-admin-institution-workshops',
  EDIT_ADMIN_INSTITUTION_COUNSELINGS = 'edit-admin-institution-counselings',
  EDIT_ADMIN_INSTITUTION_BUNDLES = 'edit-admin-institution-bundles',
  EDIT_ADMIN_INSTITUTION_USERS = 'edit-admin-institution-users',
  EDIT_ADMIN_INSTITUTION_TIMEFRAMES = 'edit-admin-institution-timeframes',
  EDIT_ADMIN_INSTITUTION_SETTINGS = 'edit-admin-institution-settings',
  EDIT_TRANSLATIONS = 'edit-admin-translations',
  EDIT_LECTURERS = 'edit-lecturers',
  MANAGE_CONTRACT_TEMPLATES = 'manage-contract-templates',

  // dynamische Rolle
  EDIT_COUNSELING_PARTICIPATION = 'edit-counseling-participation',

  // von UserPermission
  ChangePassword = 'Users.ChangePassword',
  Impersonate = 'Users.Impersonate',
  ChangeRoles = 'Users.ChangeRoles',

  // Lecturer Permissions
  VIEW_LECTURER_WORKSHOPS = 'view-lecturer-workshops',
  VIEW_LECTURER_CONTRACTS = 'view-lecturer-contracts',

  // matching software specific permissions
  CHANGE_MATCHING_CONFIG = 'change-matching-config',
  CHANGE_MATCHING_FORM_CONFIG = 'change-matching-form-config',

  CHANGE_PARTICIPATION_STATE = 'change-participation-state',
}

export enum SUPER_ADMIN_PERMISSIONS {
  ADD_INSTITUTIONS = Permission.ADD_INSTITUTIONS,
  MANAGE_INSTITUTION = Permission.MANAGE_INSTITUTION,
  MANAGE_PARTICIPATION = Permission.MANAGE_PARTICIPATION,
  MANAGE_USER = Permission.MANAGE_USER,
  MANAGE_GLOBAL_MAIL_TEMPLATES = Permission.MANAGE_GLOBAL_MAIL_TEMPLATES,

  // admin view permissions
  VIEW_SUPER_ADMIN_SIDEBAR = Permission.VIEW_SUPER_ADMIN_SIDEBAR,
  VIEW_ADMIN_DASHBOARD = Permission.VIEW_ADMIN_DASHBOARD,
  VIEW_ADMIN_INSTITUTION = Permission.VIEW_ADMIN_INSTITUTION,
  VIEW_ADMIN_INSTITUTION_DASHBOARD = Permission.VIEW_ADMIN_INSTITUTION_DASHBOARD,
  VIEW_ADMIN_INSTITUTION_WORKSHOPS = Permission.VIEW_ADMIN_INSTITUTION_WORKSHOPS,
  VIEW_ADMIN_INSTITUTION_COUNSELINGS = Permission.VIEW_ADMIN_INSTITUTION_COUNSELINGS,
  VIEW_ADMIN_INSTITUTION_BUNDLES = Permission.VIEW_ADMIN_INSTITUTION_BUNDLES,
  VIEW_ADMIN_INSTITUTION_TIMEFRAMES = Permission.VIEW_ADMIN_INSTITUTION_TIMEFRAMES,
  VIEW_ADMIN_INSTITUTION_CATEGORIES = Permission.VIEW_ADMIN_INSTITUTION_CATEGORIES,
  VIEW_ADMIN_INSTITUTION_USERS = Permission.VIEW_ADMIN_INSTITUTION_USERS,
  VIEW_ADMIN_INSTITUTION_FORM_CONFIG = Permission.VIEW_ADMIN_INSTITUTION_FORM_CONFIG,
  VIEW_ADMIN_INSTITUTION_SETTINGS = Permission.VIEW_ADMIN_INSTITUTION_SETTINGS,
  VIEW_ADMIN_INSTITUTION_EXPORTS = Permission.VIEW_ADMIN_INSTITUTION_EXPORTS,
  VIEW_ADMIN_INSTITUTION_LECTURERS = Permission.VIEW_ADMIN_INSTITUTION_LECTURERS,

  // admin edit permissions
  EDIT_INSTITUTION = Permission.EDIT_ADMIN_INSTITUTION,
  EDIT_INSTITUTION_WORKSHOPS = Permission.EDIT_ADMIN_INSTITUTION_WORKSHOPS,
  EDIT_INSTITUTION_COUNSELINGS = Permission.EDIT_ADMIN_INSTITUTION_COUNSELINGS,
  EDIT_ADMIN_INSTITUTION_BUNDLES = Permission.EDIT_ADMIN_INSTITUTION_BUNDLES,
  EDIT_ADMIN_INSTITUTION_USERS = Permission.EDIT_ADMIN_INSTITUTION_USERS,
  EDIT_INSTITUTION_TIMEFRAMES = Permission.EDIT_ADMIN_INSTITUTION_TIMEFRAMES,
  EDIT_INSTITUTION_SETTINGS = Permission.EDIT_ADMIN_INSTITUTION_SETTINGS,
  EDIT_TRANSLATIONS = Permission.EDIT_TRANSLATIONS,
  EDIT_COUNSELING_PARTICIPATION = Permission.EDIT_COUNSELING_PARTICIPATION,
  EDIT_LECTURERS = Permission.EDIT_LECTURERS,
  MANAGE_CONTRACT_TEMPLATES = Permission.MANAGE_CONTRACT_TEMPLATES,

  // default permissions
  ChangePassword = Permission.ChangePassword,
  Impersonate = Permission.Impersonate,
  ChangeRoles = Permission.ChangeRoles,

  // buddy specific permissions
  CHANGE_MATCHING_CONFIG = Permission.CHANGE_MATCHING_CONFIG,
  CHANGE_MATCHING_FORM_CONFIG = Permission.CHANGE_MATCHING_FORM_CONFIG,

  CHANGE_PARTICIPATION_STATE = Permission.CHANGE_PARTICIPATION_STATE,
}

export enum ADMIN_PERMISSIONS {
  MANAGE_INSTITUTION = Permission.MANAGE_INSTITUTION,
  MANAGE_PARTICIPATION = Permission.MANAGE_PARTICIPATION,

  // admin view permissions
  VIEW_ADMIN_DASHBOARD = Permission.VIEW_ADMIN_DASHBOARD,
  VIEW_ADMIN_INSTITUTION = Permission.VIEW_ADMIN_INSTITUTION,
  VIEW_ADMIN_INSTITUTION_DASHBOARD = Permission.VIEW_ADMIN_INSTITUTION_DASHBOARD,
  VIEW_ADMIN_INSTITUTION_WORKSHOPS = Permission.VIEW_ADMIN_INSTITUTION_WORKSHOPS,
  VIEW_ADMIN_INSTITUTION_COUNSELINGS = Permission.VIEW_ADMIN_INSTITUTION_COUNSELINGS,
  VIEW_ADMIN_INSTITUTION_BUNDLES = Permission.VIEW_ADMIN_INSTITUTION_BUNDLES,
  VIEW_ADMIN_INSTITUTION_TIMEFRAMES = Permission.VIEW_ADMIN_INSTITUTION_TIMEFRAMES,
  VIEW_ADMIN_INSTITUTION_CATEGORIES = Permission.VIEW_ADMIN_INSTITUTION_CATEGORIES,
  VIEW_ADMIN_INSTITUTION_USERS = Permission.VIEW_ADMIN_INSTITUTION_USERS,
  VIEW_ADMIN_INSTITUTION_FORM_CONFIG = Permission.VIEW_ADMIN_INSTITUTION_FORM_CONFIG,
  VIEW_ADMIN_INSTITUTION_SETTINGS = Permission.VIEW_ADMIN_INSTITUTION_SETTINGS,
  VIEW_ADMIN_INSTITUTION_EXPORTS = Permission.VIEW_ADMIN_INSTITUTION_EXPORTS,
  VIEW_ADMIN_INSTITUTION_LECTURERS = Permission.VIEW_ADMIN_INSTITUTION_LECTURERS,

  // admin edit permissions
  EDIT_INSTITUTION = Permission.EDIT_ADMIN_INSTITUTION,
  EDIT_INSTITUTION_WORKSHOPS = Permission.EDIT_ADMIN_INSTITUTION_WORKSHOPS,
  EDIT_INSTITUTION_COUNSELINGS = Permission.EDIT_ADMIN_INSTITUTION_COUNSELINGS,
  EDIT_ADMIN_INSTITUTION_BUNDLES = Permission.EDIT_ADMIN_INSTITUTION_BUNDLES,
  EDIT_ADMIN_INSTITUTION_USERS = Permission.EDIT_ADMIN_INSTITUTION_USERS,
  EDIT_INSTITUTION_TIMEFRAMES = Permission.EDIT_ADMIN_INSTITUTION_TIMEFRAMES,
  EDIT_INSTITUTION_SETTINGS = Permission.EDIT_ADMIN_INSTITUTION_SETTINGS,
  EDIT_TRANSLATIONS = Permission.EDIT_TRANSLATIONS,
  EDIT_LECTURERS = Permission.EDIT_LECTURERS,
  EDIT_COUNSELING_PARTICIPATION = Permission.EDIT_COUNSELING_PARTICIPATION,
  MANAGE_CONTRACT_TEMPLATES = Permission.MANAGE_CONTRACT_TEMPLATES,

  CHANGE_PARTICIPATION_STATE = Permission.CHANGE_PARTICIPATION_STATE,
}

export enum BERATER_PERMISSIONS {
  VIEW_ADMIN_DASHBOARD = Permission.VIEW_ADMIN_DASHBOARD,
  VIEW_ADMIN_INSTITUTION_COUNSELINGS = Permission.VIEW_ADMIN_INSTITUTION_COUNSELINGS,
  VIEW_ADMIN_INSTITUTION_DASHBOARD = Permission.VIEW_ADMIN_INSTITUTION_DASHBOARD,
  MANAGE_INSTITUTION = Permission.MANAGE_INSTITUTION,
  EDIT_COUNSELING_PARTICIPATION = Permission.EDIT_COUNSELING_PARTICIPATION,
}

export enum LECTURER_PERMISSIONS {
  VIEW_ADMIN_INSTITUTION_DASHBOARD = Permission.VIEW_ADMIN_INSTITUTION_DASHBOARD,
  MANAGE_INSTITUTION = Permission.MANAGE_INSTITUTION,
  VIEW_LECTURER_WORKSHOPS = Permission.VIEW_LECTURER_WORKSHOPS,
  VIEW_LECTURER_CONTRACTS = Permission.VIEW_LECTURER_CONTRACTS,
  CHANGE_PARTICIPATION_STATE = Permission.CHANGE_PARTICIPATION_STATE,
  MANAGE_PARTICIPATION = Permission.MANAGE_PARTICIPATION,
}

export enum PARTICIPANT_PERMISSIONS {}
